var _style, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLoader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 422 421",
    style: {
      enableBackground: "new 0 0 422 421"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#186749;}\n\t.st2{fill:#0D0D0D;}\n\t.st3{fill:#EE273F;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M148.1,0C66.6,0,0.5,66.1,0.5,147.6V420h272.4c81.5,0,147.6-66.1,147.6-147.6c0-74.3-54.9-135.8-126.4-146.1 C283.8,54.9,222.4,0,148.1,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49,373h202.3V170.7H49V373z M150.2,352c-44.3,0-80.1-35.9-80.1-80.1c0-44.3,35.9-80.1,80.1-80.1 c44.3,0,80.1,35.9,80.1,80.1C230.3,316.1,194.4,352,150.2,352z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M149.6,22.5c30.3,0,59.5,11,82.2,30.8c22.6,19.7,37.3,46.8,41.6,76.2l2.4,16.6l16.6,2.4 c29.5,4.2,56.5,19,76.3,41.6c19.9,22.8,30.8,52,30.8,82.2c0,69-56.1,125.1-125.1,125.1H24.5V147.6C24.5,78.6,80.6,22.5,149.6,22.5z  M149.6,0C68.1,0,2,66.1,2,147.6V420h272.4c81.5,0,147.6-66.1,147.6-147.6c0-74.3-54.9-135.8-126.4-146.1 C285.3,54.9,223.9,0,149.6,0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M205.5,271.8c0,30.6-24.8,55.3-55.3,55.3c-30.6,0-55.3-24.8-55.3-55.3c0-30.6,24.8-55.3,55.3-55.3 C180.7,216.5,205.5,241.3,205.5,271.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M275.5,170.7c55.9,0,101.2,45.3,101.2,101.2c0,55.9-45.3,101.2-101.2,101.2V170.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M49,145.4C49,89.5,94.3,44.2,150.2,44.2c55.9,0,101.2,45.3,101.2,101.2H49z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLoader);
export default __webpack_public_path__ + "static/media/ic_loader.1c2e9b6b221d4ecb1b490e30be1a2848.svg";
export { ForwardRef as ReactComponent };